import {eventListenerService} from '@/modules/common/services'
import {urlUtil} from '@/modules/common/utils'
import {v4 as uuidv4} from 'uuid';

const iframeId = urlUtil.getParameterByName("iframeId")
const activeListeners = {}

window.addEventListener("message", function (e) {
  if (typeof e.data  !== 'string' && e.data.source === 'frontage-message') {
    eventListenerService.emit('on-frontage-message', e.data.message)
  }
});

const postAndListen = (params, callback) => {
  // prevent adding multiple listeners for the same message
  if (!activeListeners[params.message]) {
    window.addEventListener("message", function (e) {
      if(typeof e.data  == 'string') {
        const resp = e.data ? JSON.parse(e.data) : ''
        if(resp.target == 'message_to_vue_app') {
          callback(resp)
        }
      }else{
        callback(e)
      }
    });
    activeListeners[params.message] = true
  }

  let payload = {event: params.message, origin: iframeId}
  if (params.data){
    payload.data = params.data
  }

  window.parent.postMessage(payload, "*");
}

const post = (message, data) => {
  let payload = {event: message, origin: iframeId}
  if (data){
    payload.data = data
  }
  window.parent.postMessage(payload, "*")
}

/**
 * Retrieves data from the POV store by sending a post message request.
 * It makes sure that it catches the corresponding response message from POV by
 * sending a unique request-id that POV side echos.
 * @param {string} path - The path to the data in the store (e.g. 'ModuleStore/nestedPath')
 * @returns {Promise} Resolves with the store data or rejects with an error
 */
const getDataFromPOVStore = (path) => {
  return new Promise((resolve, reject) => {
    const requestId = uuidv4();

    const responseHandler = (e) => {
      if (typeof e.data !== 'string') {
        if (e.data.message?.event === 'store-data-response') {
          // Only process the response if it matches our request ID
          if (e.data.message.data.requestId === requestId) {
            window.removeEventListener('message', responseHandler)
            clearTimeout(timeoutId)
            if (e.data.message.error) {
              reject(e.data.message.error)
            } else {
              resolve(e.data.message.data.response)
            }
          }
        }
      }
    }

    window.addEventListener('message', responseHandler)

    const timeoutId = setTimeout(() => {
      window.removeEventListener('message', responseHandler)
      reject('Request timed out after 2 seconds')
    }, 2000)

    post('povMessage', {
      eventName: 'get-data-from-store',
      payload: { requestId, path }
    });
  })
}

const openWindow = (url, options = {}) => {
  const data = {...options, url}
  post('open_window', data)
}

export default {
    post,
    postAndListen,
    openWindow,
    getDataFromPOVStore
};
